<template>
    <div>
        <div class="card">
            <div class="card-body">
                <fieldset>
                    <legend class="text-uppercase font-size-sm font-weight-bold">Template</legend>
                    <div class="col-8">
                        <basic-file-input :vertical="true" :rule="'required fileType:zip'" accept=".zip" description="zip file included html & image" @change="changeFile" :label="'File'"
                                          downloadName="download sample zip file" downloadLocation="/assets/document/mailLayout_sample.zip"/>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <fieldset>
                    <legend class="text-uppercase font-size-sm font-weight-bold">Template Options</legend>
                    <div class="col-8">
                        <basic-input label="Name" :vertical="true" :disabled="true" :rule="'required'" v-model="params.name"/>
                    </div>
                    <div class="col-8">
                        <select2 :options="languageOptions" :vertical="true" v-model="params.lang" :label="'Language'" rule="required"/>
                    </div>
                    <div class="col-8">
                        <select2 :options="clientCdOptions" :vertical="true" v-model="params.clientCd" :label="'Client Code'" rule="required"/>
                    </div>
                </fieldset>
                <div class="col-12">
                    <button class="btn btn-ums" style="width: 100%" @click="save" v-if="hasRole($const.ROLES.MAIL_LAYOUT_SAVE)">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import BasicInput from "@/components/form/input/BasicInput";
    import BasicFileInput from "@/components/form/input/BasicFileInput";
    import Select2  from "@/components/form/select/Select2"
    import validation from "@/config/mixin/validation";
    import api from '@/api/layout'
    export default {
        name: "MailTemplateLayoutUpdate",
        components: {
            BasicInput,
            BasicFileInput,
            Select2,
        },
        mixins:[validation],
        props: ['layout'],
        data() {
            return {
                params: {
                    name:'',
                    clientCd:'',
                    lang:''
                },
                file:null,
            }
        },
        computed: {
            languageOptions:function() {
                return this.$store.getters[this.$const.GETTERS.LANGUAGE_OPTIONS]()
            },
            clientCdOptions:function() {
                return this.$store.getters[this.$const.GETTERS.CLIENT_CD_OPTIONS]()
            }
        },
        mounted() {
            this.$forceUpdate()
            if(!this.layout) {
                this.historyBack()
            } else {
                this.params = $.extend(true,{},this.layout)
            }
            if (!$().uniform) {
                console.warn('Warning - uniform.min.js is not loaded.');
                return;
            }

            // File input
            $('.form-control-uniform').uniform();

            // Custom select
            $('.form-control-uniform-custom').uniform({
                fileButtonClass: 'action btn bg-blue',
                selectClass: 'uniform-select bg-pink-400 border-pink-400'
            });
        },
        methods: {
            save:function() {
                if(!this.validationCheck()) return;

                api.saveLayout(this.params,this.file).then((result)=>{
                    if(result && result.data.code === 1000) {
                        this.$notify.success(result.data.message)
                        this.$router.push({name: 'MailLayout'})
                    }
                })
            },
            changeFile: function(file) {
                this.file = file
            }
        }
    }
</script>

<style scoped>

</style>
